import '../stylesheets/wordle.scss';

window.components = {
  ...window.components,
  'Wordle': require('../components/Wordle')
}

window.mountComponents(window.components);
